// extracted by mini-css-extract-plugin
export default {"container":"MessageList_container__Ma7mj"};